/**
 * formatDate.tsx - Date Formatting Utility
 */

export function formatDate(string) {
    const date = new Date(string)
    const month = date.toLocaleString('default', { month: 'long' });

    function addZero(i) {
        if (i < 10) { i = "0" + i }
        return i;
    }

    return `${month} ${date.getDate()}, ${date.getFullYear()} · ${date.getHours()}:${addZero(date.getMinutes())}`
}


// formatDate to dd/mm/yyyy
export function formatDateToDDMMYYYY(string) {
    // A bare YYYY-MM-DD is parsed as UTC midnight by the Date constructor, which
    // then renders as the previous day at any negative UTC offset. Build it as a
    // local date instead. Inputs that carry a time are left to the constructor.
    const dateOnly = /^(\d{4})-(\d{2})-(\d{2})$/.exec(string)
    const date = dateOnly
        ? new Date(Number(dateOnly[1]), Number(dateOnly[2]) - 1, Number(dateOnly[3]))
        : new Date(string)
    return date.toLocaleDateString('default', { day: '2-digit', month: '2-digit', year: 'numeric' });
}